import { useState } from 'react';

/** Manages per-row visibility state for header value fields (password toggle). */
export const useHeaderVisibility = () => {
  const [visibleHeaders, setVisibleHeaders] = useState<Set<number>>(new Set());

  const toggle = (index: number) => {
    setVisibleHeaders((prev) => {
      const next = new Set(prev);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }
      return next;
    });
  };

  const shiftAfterRemove = (index: number) => {
    setVisibleHeaders((prev) => {
      const next = new Set<number>();
      for (const i of prev) {
        if (i < index) {
          next.add(i);
        } else if (i > index) {
          next.add(i - 1);
        }
      }
      return next;
    });
  };

  const reset = () => setVisibleHeaders(new Set());

  return { visibleHeaders, toggle, shiftAfterRemove, reset };
};
